import React from "react";
import PropTypes from "prop-types";

export default function Star({ value, color = "#A9A8A8" }) {

	return (
		<svg
			className="svg star"
			width="13"
			height="13"
			viewBox="0 0 13 13"
			xmlns="http://www.w3.org/2000/svg"
		>
			{value > 0 && value < 1 ? (
				<>
					<path
						// eslint-disable-next-line max-len
						d="M5.25249 0.373313L6.25904 2.93819H8.8232C9.33479 2.93819 9.60187 3.54836 9.25552 3.92588L7.40708 5.94066L8.19167 8.65691C8.34046 9.17203 7.7811 9.60225 7.32344 9.3247L4.70517 7.7368L2.07359 9.32533C1.61648 9.60126 1.05884 9.17255 1.20599 8.65832L1.98402 5.9394L0.154148 3.92358C-0.189212 3.54533 0.0784472 2.93819 0.588561 2.93819H3.12051L4.16163 0.367383C4.36117 -0.125332 5.0583 -0.121542 5.25249 0.373313Z"
						fill={color}
						data-testid="half-star"
					/>
					<g clipPath="url(#clip0_3534_263830)">
						<path
							// eslint-disable-next-line max-len
							d="M5.25249 0.373313L6.25904 2.93819H8.8232C9.33479 2.93819 9.60187 3.54836 9.25552 3.92588L7.40708 5.94066L8.19167 8.65691C8.34046 9.17203 7.7811 9.60225 7.32344 9.3247L4.70517 7.7368L2.07359 9.32533C1.61648 9.60126 1.05884 9.17255 1.20599 8.65832L1.98402 5.9394L0.154148 3.92358C-0.189212 3.54533 0.0784472 2.93819 0.588561 2.93819H3.12051L4.16163 0.367383C4.36117 -0.125332 5.0583 -0.121542 5.25249 0.373313Z"
							fill="#1C72E7"
						/>
					</g>
					<defs>
						<clipPath id="clip0_3534_263830">
							<path
								fill="#fff"
								d="M0 0H4.7V13H0z"
							/>
						</clipPath>
					</defs>
				</>
			) : (
				<path
					// eslint-disable-next-line max-len
					d="M5.25249 0.373313L6.25904 2.93819H8.8232C9.33479 2.93819 9.60187 3.54836 9.25552 3.92588L7.40708 5.94066L8.19167 8.65691C8.34046 9.17203 7.7811 9.60225 7.32344 9.3247L4.70517 7.7368L2.07359 9.32533C1.61648 9.60126 1.05884 9.17255 1.20599 8.65832L1.98402 5.9394L0.154148 3.92358C-0.189212 3.54533 0.0784472 2.93819 0.588561 2.93819H3.12051L4.16163 0.367383C4.36117 -0.125332 5.0583 -0.121542 5.25249 0.373313Z"
					fill={value >= 1 ? "#1C72E7" : color}
				/>
			)}
		</svg>
	);
}

Star.propTypes = {
	value: PropTypes.number,
	color: PropTypes.string
};

Star.defaultProps = {
	value: 1
};
